__webpack_require__.p = "https://gingopolisdjango.blob.core.windows.net/fomoapp/static/dist/";